import React, { useState, useEffect } from "react";
import { ProfileService } from "../../../../services/ProfileService";

const Notification = () => {
  var background;
  const [readNotifications, setReadNotification] = useState(0);
  const [notificationsList, setNotificationsList] = useState([]);
  const [x, setX] = useState();

  useEffect(() => {
    getNotificationsList();
  }, []);

  const readNotificationList = (notificationId) => {
    ProfileService.updateNotifications(notificationId).then((response) => {
      try {
        let dataCheck = response.data;
        if (dataCheck !== null) {
          getNotificationsList();
          //setReadNotification(notificationId)
        }
      } catch (error) {
        console.log("readNotification" + JSON.stringify(error));
      }
    });
  };
  const getNotificationsList = () => {
    ProfileService.getNotifications().then((response) => {
      try {
        if (response.data !== null) {
          setNotificationsList(response.data.notifications);
        }
      } catch (err) {
        console.log("notificationsList" + JSON.stringify(err));
      }
    });
  };

  const readApi = (notificationId) => {
    readNotificationList(notificationId);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const onDeleteNotification = (deletenotificationId) => {
    deleteNotifications(deletenotificationId);
  };

  const deleteNotifications = (deletenotificationId) => {
    ProfileService.deletenotification(deletenotificationId).then((response) => {
      try {
        if (response.data != null) {
          // toast.success("Notification deleted successfully");
          getNotificationsList();
        }
      } catch (err) {
        console.error("deleteEducation" + JSON.stringify(err));
      }
    });
  };
  const timeDifference = (updatedOn) => {
    const date1 = new Date(updatedOn);
    var currentTimeInMilliseconds = Date.now();
    const date2 = new Date(currentTimeInMilliseconds);

    let noOfDays = getDifferenceInDays(date1, date2);
    let noOfHours = getDifferenceInHours(date1, date2);
    let noOfMins = getDifferenceInMinutes(date1, date2);
    let noOfSecs = getDifferenceInSeconds(date1, date2);
    if (noOfDays > 6) {
      const date = new Date(date1);
      return <span>{date.toLocaleDateString()}</span>;
    } else if (noOfDays >= 2 && noOfDays <= 6) {
      return <span>{Math.floor(noOfDays) + " days ago"}</span>;
    } else if (noOfDays >= 1 && noOfDays < 2) {
      return <span>{Math.floor(noOfDays) + " day ago"}</span>;
    } else if (noOfHours > 23 && noOfHours <= 24) {
      return <span>{"1 day ago"}</span>;
    } else if (noOfHours >= 2 && noOfHours <= 23) {
      return <span>{Math.floor(noOfHours) + " hours ago"}</span>;
    } else if (noOfHours >= 1 && noOfHours <= 2) {
      return <span>{Math.floor(noOfHours) + " hour ago"}</span>;
    } else if (noOfMins >= 2 && noOfHours <= 59) {
      return <span>{Math.floor(noOfMins) + " minutes ago"}</span>;
    } else if (noOfMins >= 1 && noOfHours < 2) {
      return <span>{Math.floor(noOfMins) + " minute ago"}</span>;
    } else if (noOfSecs >= 1 && noOfSecs <= 59) {
      return <span>{"Few seconds ago"}</span>;
    }
  };

  function getDifferenceInDays(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60 * 60 * 24);
  }

  function getDifferenceInHours(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60 * 60);
  }

  function getDifferenceInMinutes(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / (1000 * 60);
  }

  function getDifferenceInSeconds(date1, date2) {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / 1000;
  }
  return (
    <>
      <div
        className="notificationsContainer 
                        order-1 
                        max-lg:col-span-1 min-lg:col-span-3 min-xl:col-span-3 min-2xl:col-span-2 "
      >
        <div className="notificationsWrapper flex flex-col gap-9 max-md:mx-4 min-lg:w-full">
          <div className="notifications max-lg:pb-12">
            <div className="notificationsTitle text-2xl font-bold text-primary-dark pb-3 max-md:pt-5">
              Notifications
            </div>

            <div
              className="notificationsWrapper max-lg:pb-5 overflow-y-scroll 
                                scrollbar-none hover:scrollbar-thin scrollbar-thumb-rounded-md scrollbar-thumb-Blue-600 scrollbar-track-Gray-200"
            >
              <div className="grid grid-cols-1 gap-4 min-md:p-1 pr-2">
                {notificationsList.length > 0 &&
                  notificationsList.map((notificationItem) => (
                    <>
                      {notificationItem.status.value !== "Read" ? (
                        <>
                          <div className="notification relative bg-blue-50 rounded-xl overflow-hidden shadow-md transition-all ease-in-out duration-200">
                            <div
                              className=" pl-4 pr-10 t-py-5 border-l-[6px] border-l-primary-blue
                                                      flex flex-row min-lg:items-center justify-between
                                                      "
                            >
                              <a
                                href=""
                                className="absolute right-4 top-4 z-50 max-lg:top-0"
                              >
                                <div
                                  id="nav-toggle"
                                  className="group cursor-pointer max-md:drop-shadow-2xl hover:drop-shadow-sm transition-all ease-in-out z-40 absolute top-0 max-md:top-4 right-0"
                                >
                                  <div className="myjob_options absolute t-right-10 min-md:top-4 min-xl:top-10 z-40 t-right-dot">
                                    <span className="bg-primary-dark block w-[3px] h-[3px] m-[2px] rounded-full"></span>
                                    <span className="bg-primary-dark block w-[3px] h-[3px] m-[2px] rounded-full"></span>
                                    <span className="bg-primary-dark block w-[3px] h-[3px] m-[2px] rounded-full"></span>
                                  </div>
                                  <nav className="hidden group-hover:block  absolute z-30 -left-[215px] min-md:top-0 min-xl:top-7 w-[200px] t-delete-notify-height h-[120px] t-shadow-lg t-delete-notify-height rounded-lg transition ease-in-out t-top-del t-left-del-bt">
                                    <div className="relative max-md:absolute text-primary-dark tracking-widest font-semibold w-full text-sm z-30">
                                      <ul className="navbar absolute z-40 flex flex-col rounded-lg gap-2 left-0 right-0 p-[5%] bg-primary-gray ">
                                        <li
                                          className="py-2  px-3 hover:text-Gray-500 menuItem"
                                          onClick={() =>
                                            onDeleteNotification(
                                              notificationItem.id
                                            )
                                          }
                                        >                                          
                                          <a href="#">Delete</a>
                                        </li>
                                      </ul>
                                    </div>
                                  </nav>
                                </div>
                              </a>
                              <div className="notification_Dot max-lg:mt-1 w-2 h-2 bg-primary-blue rounded-full pr-1"></div>
                              <div className="text-sm pr-7 basis-[97%] t-basis-notify pl-2 max-lg:pl-3">
                                <span
                                  key={notificationItem.id}
                                  onClick={() => readApi(notificationItem.id)}
                                >
                                  {notificationItem.description}
                                </span>
                                <span className="pl-5 ">
                                  <a
                                    href={notificationItem.link}
                                    target="_blank"
                                  >
                                    {notificationItem.link}
                                  </a>
                                </span>
                              </div>
                              <div className=" font-semibold pb-1 basis-[2%] t-basis-date justify-end">
                                {timeDifference(notificationItem.createdOn)}
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="notification relative bg-primary-white rounded-xl overflow-hidden shadow-md transition-all ease-in-out duration-200 "
                            onClick={() => readApi(notificationItem.id)}
                          >
                            <div
                              className=" pl-4 pr-10 t-py-5 border-l-[6px] border-l-gray-500
                                                      flex flex-row min-lg:items-center justify-between
                                                      "
                            >
                              <a
                                href=""
                                className="absolute right-4 top-4 z-50 max-lg:top-0"
                              >
                                <div
                                  id="nav-toggle"
                                  className="group cursor-pointer  max-md:drop-shadow-2xl hover:drop-shadow-sm transition-all ease-in-out z-40 absolute top-0 max-md:top-4 right-0"
                                >
                                  <div className="myjob_options absolute t-right-10 min-md:top-4 min-xl:top-10 z-40 t-right-dot">
                                    <span className="bg-primary-dark block w-[3px] h-[3px] m-[2px] rounded-full"></span>
                                    <span className="bg-primary-dark block w-[3px] h-[3px] m-[2px] rounded-full"></span>
                                    <span className="bg-primary-dark block w-[3px] h-[3px] m-[2px] rounded-full"></span>
                                  </div>
                                  <nav className="hidden group-hover:block  absolute z-30 -left-[215px] min-md:top-0 min-xl:top-7 w-[200px] h-[120px] t-shadow-lg rounded-lg transition t-delete-notify-height ease-in-out t-top-del t-left-del-bt">
                                    <div className="relative max-md:absolute text-primary-dark tracking-widest font-semibold w-full text-sm z-30">
                                      <ul className="navbar absolute z-40 flex flex-col rounded-lg gap-2 left-0 right-0 p-[5%] bg-primary-gray ">
                                        <li className="py-2  px-3 hover:text-Gray-500 menuItem">
                                          <a
                                            href="#"
                                            onClick={() =>
                                              onDeleteNotification(
                                                notificationItem.id
                                              )
                                            }
                                          >
                                            Delete
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </nav>
                                </div>
                              </a>
                              <div className="notification_Dot max-lg:mt-1 w-2 h-2 bg-primary-blue hidden rounded-full pr-1"></div>
                              <div className="text-sm pr-7 basis-[97%] t-basis-notify pl-2 max-lg:pl-3">
                                <span
                                  key={notificationItem.id}
                                  onClick={() => readApi(notificationItem.id)}
                                >
                                  {notificationItem.description}
                                </span>
                                <span className="pl-5 ">
                                  <a
                                    href={notificationItem.link}
                                    target="_blank"
                                  >
                                    {notificationItem.link}
                                  </a>
                                </span>
                              </div>
                              <div className=" font-semibold pb-1 basis-[2%] t-basis-date justify-end">
                                {timeDifference(notificationItem.createdOn)}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notification;
